<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col sm="7">
              <h4 class="chr-h3"> <b-icon icon="globe2"></b-icon> <translate>Company data:</translate></h4>
              <b-card class="shadow-sm" no-body>
                 <b-list-group flush class="list-dense">
                  <b-list-group-item>
                    <span class="user-details" v-translate>Agency code:</span><span > {{ userData.code }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Agency name:</span><span> {{ userData.name }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Commision:</span><span> {{ userData.groupName }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Company name:</span><span >{{ userData.companyName }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Cod fiscal:</span><span> {{ userData.vatNo }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Nr. Reg Comertului:</span><span > {{ userData.companyNo }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Address:</span><span> {{ userData.address }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Account:</span><span> {{ userData.bankAccount }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Bank:</span><span> {{ userData.bankName }}</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate>Email:</span><span><a :href="'mailto:' + userData.email">{{ userData.email }}</a></span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span class="user-details" v-translate >Phone:</span><span> {{ userData.tel }}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
            <b-col sm="5">
              <h4 class="chr-h3"> <b-icon icon="globe2"></b-icon> <translate>User data:</translate></h4>
               <b-list-group>
                <b-list-group-item>
                  <span class="user-name" v-translate>Login name:</span><span> {{ userData.username }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-name" v-translate>Name:</span><span> {{ userData.title }} {{ userData.fname }} {{ userData.lname }}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <span class="user-name" v-translate>Email:</span><span> <a :href="'mailto:' + userData.email"> {{ userData.email }}</a></span>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>

<style lang="scss" scoped>
  .list-dense div {
    padding: 0.6rem 1rem;
  }
  .user-details,
  .user-name {
    display: inline-block;
    font-weight: 700;
    color: #000;
  }
  .user-details {
    width: 42%;
  }
</style>
